import { RootState } from "./../../app/store";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SnackbarAlertProps, GlobalSnackbarState } from "./globalSnackbarTypes";

const initialState: GlobalSnackbarState = {
  open: false,
  alertProps: {
    title: "",
    message: "",
    severity: "success",
    duration: 6000,
    isError: false,
    dateAndTime: "",
    requestUrl: "",
    statusCode: "",
    xRequestID: "",
  },
};

const globalSnackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    openSnackbar: (state, action: PayloadAction<SnackbarAlertProps>) => {
      state.open = true;
      state.alertProps.title = action.payload.title;
      state.alertProps.message = action.payload.message;
      state.alertProps.severity = action.payload.severity;
      state.alertProps.duration = action.payload.duration ?? 6000;
      if (action.payload.severity === "error") {
        state.alertProps.isError = true;
      } else {
        state.alertProps.isError = false;
      }
      state.alertProps.dateAndTime = action.payload.dateAndTime;
      state.alertProps.requestUrl = action.payload.requestUrl;
      state.alertProps.statusCode = action.payload.statusCode;
      state.alertProps.xRequestID = action.payload.xRequestID;
    },
  },
});

export const { setOpen, openSnackbar } = globalSnackbarSlice.actions;

export const selectOpen = (state: RootState): boolean => state.globalSnackbar.open;
export const selectAlertProps = (state: RootState): SnackbarAlertProps => state.globalSnackbar.alertProps;
export const selectIsError = (state: RootState): boolean => state.globalSnackbar.alertProps.isError ?? false;

export default globalSnackbarSlice.reducer;
